// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none){.carousel-info-description[data-v-d37b1546]{margin:1rem 0}}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
